import React from 'react';

import AutoFilledForm from './AutoFilledForm';
import SearchForm from './SearchForm';
import { useSearchParams } from 'react-router-dom';

const Search = () => {
  const [searchParams] = useSearchParams();
  const productId = searchParams.get('i');

  if (productId) {
    return <AutoFilledForm productId={parseInt(productId, 10)} />;
  }

  return <SearchForm />;
};

export default Search;
